module.exports = __webpack_public_path__ + "img/abstract.fb59c387.svg";